<template>
  <v-container pa-0>
    <v-layout>
      <v-container class="justify">
        <v-flex xs12 mb-2>
          <h2 class="font-weight-light secondary--text" v-text="page_title"></h2>
          <v-spacer></v-spacer>
          <span
            class="mt-2 secondary--text"
          >{{ months[getDate.getMonth()] }} {{ getDate.getDate() }}, {{getDate.getFullYear()}}</span>
        </v-flex>
        <template>
          <v-card>
            <v-card-title class="pb-0">
              <v-layout row wrap>
                <v-flex xs9>
                  <div>
                    <h3 v-text="marshal.full_name"></h3>
                    <h4 class="font-weight-regular" v-text="marshal.status"></h4>
                    <h5 class="font-weight-regular">
                      <span v-text="marshal.state"></span>
                      <span>,</span>
                      <span v-text="marshal.route_number"></span>
                    </h5>
                  </div>
                </v-flex>
                <v-flex xs3>
                  <div class="ml-auto">
                    <v-btn color="primary" @click="show_stats=false" v-if="show_stats">MERCHANTS</v-btn>
                    <v-btn color="success" @click="show_stats=true" v-else>ANALYTICS</v-btn>
                  </div>
                </v-flex>
              </v-layout>
            </v-card-title>

            <v-card-text class="pt-0">
              <v-flex>
                <v-layout column>
                  <v-flex>
                    <div class="mt-2"></div>
                    <v-spacer></v-spacer>
                    <div>
                      <p class="mb-0 mt-3">
                        <i>Last Login</i>
                      </p>
                      <h3 v-text="marshal.login_location" class="font-weight-regular"></h3>
                      <h5 class="font-weight-regular">
                        <span v-text="convertUTCTime(marshal.last_login)"></span>
                      </h5>
                    </div>
                  </v-flex>

                  <div v-if="show_stats">
                    <v-flex xs12 my-5>
                      <v-layout column>
                        <div v-if="view_report">
                          <v-flex>
                            <v-btn color="secondary" flat @click="view_report = false">
                              <v-icon class="mr-2">keyboard_backspace</v-icon>Back to Analytics
                            </v-btn>
                          </v-flex>
                          <v-flex my-5>
                            <v-layout column>
                              <v-card-title>
                                Reports
                                <v-spacer></v-spacer>
                                <v-text-field
                                  v-model="reportSearch"
                                  append-icon="search"
                                  label="Search Reports"
                                  single-line
                                  hide-details
                                ></v-text-field>
                              </v-card-title>
                              <v-data-table
                                :headers="reportsHeaders"
                                :items="reports"
                                :expand="expand"
                                :search="reportSearch"
                                item-key="id"
                              >
                                <template slot="items" slot-scope="props">
                                  <tr @click="props.expanded = !props.expanded">
                                    <td>{{ props.item.terminal_uuid }}</td>
                                    <td>{{ props.item.merchant_name }}</td>
                                    <td>{{ props.item.merchant_address }}</td>
                                    <td>{{ convertUTCTime(props.item.created) }}</td>
                                  </tr>
                                </template>
                                <template slot="expand" slot-scope="props">
                                  <v-card flat>
                                        <v-card-text class="grey lighten-3">
                                          <v-layout column>
                                            <v-flex>
                                              <v-layout row wrap>
                                                <div class="mx-4 text-xs-center mb-5">
                                                  <h3>Comment</h3>
                                                  <h2 class="font-weight-light" v-text="props.item.comment"></h2>
                                                </div>
                                                <div class="mx-4 text-xs-center mb-5">
                                                  <h3>Remark</h3>
                                                  <h2 class="font-weight-light" v-text="props.item.remark"></h2>
                                                </div>
                                                <div
                                                  class="mx-4 text-xs-center mb-5"
                                                  v-if="props.item.further_remark"
                                                >
                                                  <h3>Further Remark</h3>
                                                  <h2
                                                    class="font-weight-light"
                                                    v-text="props.item.further_remark"
                                                  ></h2>
                                                </div>
                                                <div class="mx-4 text-xs-center mb-5">
                                                  <h3>Ref No.</h3>
                                                  <h2 class="font-weight-light" v-text="props.item.tx_ref"></h2>
                                                </div>
                                                <div class="mx-4 text-xs-center mb-5">
                                                  <h3>Amount</h3>
                                                  <h2 class="font-weight-light" v-text="props.item.tx_amount"></h2>
                                                </div>
                                                <div
                                                  v-if="props.item.emergency_visit"
                                                  class="mx-4 text-xs-center mb-5"
                                                >
                                                  <h3>Emergency</h3>
                                                  <h2
                                                    class="font-weight-light"
                                                    v-text="props.item.emergency_visit"
                                                  ></h2>
                                                </div>
                                                <div class="mx-4 mb-5 text-xs-center">
                                                  <h3>Data Providers</h3>
                                                  <h2
                                                    class="font-weight-light"
                                                    v-text="props.item.data_providers"
                                                  ></h2>
                                                </div>
                                                <div class="mx-4 mb-5 text-xs-center">
                                                  <h3>Item</h3>
                                                  <h2 class="font-weight-light" v-text="props.item.item_name"></h2>
                                                </div>
                                                <div class="text-xs-center mb-5">
                                                  <h3>Qty</h3>
                                                  <h2 class="font-weight-light" v-text="props.item.item_quantity"></h2>
                                                </div>
                                              </v-layout>
                                            </v-flex>
                                          </v-layout>
                                        </v-card-text>
                                      </v-card>
                                </template>
                              </v-data-table>
                            </v-layout>
                          </v-flex>
                        </div>
                        <div v-else>
                          <v-tabs v-model="active" left slider-color="primary">
                            <v-tab v-for="tabs in tab_title" :key="tabs">{{ tabs }}</v-tab>
                            <v-spacer/>
                            <v-btn color="success darken-3" @click="view_report = true">View Reports</v-btn>
                            <v-dialog v-model="download_anal" max-width="290">
                              <v-btn color="accent darken-3" slot="activator">Download</v-btn>
                              <v-card class="elevation-3">
                                <v-card-title class="headline">Select Date</v-card-title>
                                <v-card-text class="pb-0">
                                  <v-layout row wrap>
                                    <v-flex xs12 pr-0>
                                      <div>
                                        <h3>Start Date</h3>
                                        <v-dialog
                                          ref="start_dialog"
                                          v-model="start_modal"
                                          :return-value.sync="start_date"
                                          persistent
                                          lazy
                                          full-width
                                          width="290px"
                                        >
                                          <v-text-field
                                            slot="activator"
                                            v-model="start_date"
                                            label="Picker in dialog"
                                            prepend-icon="event"
                                            solo
                                            readonly
                                          ></v-text-field>
                                          <v-date-picker v-model="start_date" scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                              flat
                                              color="primary"
                                              @click="start_modal = false"
                                            >Cancel</v-btn>
                                            <v-btn
                                              flat
                                              color="primary"
                                              @click="$refs.start_dialog.save(start_date)"
                                            >OK</v-btn>
                                          </v-date-picker>
                                        </v-dialog>
                                      </div>
                                    </v-flex>

                                    <v-flex xs12>
                                      <div>
                                        <h3>End Date</h3>
                                        <v-dialog
                                          ref="end_dialog"
                                          v-model="end_modal"
                                          :return-value.sync="end_date"
                                          persistent
                                          lazy
                                          full-width
                                          width="290px"
                                        >
                                          <v-text-field
                                            slot="activator"
                                            v-model="end_date"
                                            label="Picker in dialog"
                                            prepend-icon="event"
                                            solo
                                            readonly
                                          ></v-text-field>
                                          <v-date-picker v-model="end_date" scrollable>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                              flat
                                              color="primary"
                                              @click="end_modal = false"
                                            >Cancel</v-btn>
                                            <v-btn
                                              flat
                                              color="primary"
                                              @click="$refs.end_dialog.save(end_date)"
                                            >OK</v-btn>
                                          </v-date-picker>
                                        </v-dialog>
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                                <v-card-actions>
                                  <v-flex justify-end pr-4 pb-3>
                                    <v-btn
                                      color="error"
                                      flat
                                      @click.native="download_anal = false"
                                    >Cancel</v-btn>
                                    <v-btn 
                                      color="accent darken-3"
                                      :loading="downloading"
                                    >
                                      <download-excel
                                        class
                                        :data="reports"
                                        :fields="json_fields"
                                        :fetch="downloadReports"
                                        type="csv"
                                        name="report.xls"
                                      >Download Reports</download-excel>
                                    </v-btn>
                                    <!-- <v-btn color="accent darken-3" @click="downloadReports()">Download</v-btn> -->
                                  </v-flex>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                            <v-tab-item v-for="n in 2" :key="n">
                              <v-card flat>
                                <v-card-text class="px-0">
                                  <v-layout row wrap>
                                    <v-flex xs4>
                                      <v-card
                                        color="secondary"
                                        class="full-width mr-2 py-4 px-1 text-xs-center"
                                        dark
                                      >
                                        <v-layout row wrap>
                                          <v-flex xs12 sm5 justify-center>
                                            <img
                                              src="@/assets/merchants.svg"
                                              alt="merchants"
                                              width="60"
                                              height="60"
                                            >
                                          </v-flex>
                                          <v-flex>
                                            <div class="pl-2">
                                              <h2
                                                v-text="marshal.expected"
                                                class="py-2 text-sm-left"
                                              ></h2>
                                              <h5 class="font-weight-regular">Expected Visitations</h5>
                                            </div>
                                          </v-flex>
                                        </v-layout>
                                      </v-card>
                                    </v-flex>
                                    <v-flex xs4>
                                      <v-card
                                        color="success"
                                        class="full-width mr-2 py-4 px-1 text-xs-center"
                                        dark
                                      >
                                        <v-layout row wrap>
                                          <v-flex xs12 sm5 justify-center>
                                            <img
                                              src="@/assets/visit.svg"
                                              alt="marshal"
                                              width="60"
                                              height="60"
                                            >
                                          </v-flex>
                                          <v-flex>
                                            <div class="pl-2">
                                              <h2 v-text="marshal.done" class="py-2 text-sm-left"></h2>
                                              <h5 class="font-weight-regular">Visitations Done</h5>
                                            </div>
                                          </v-flex>
                                        </v-layout>
                                      </v-card>
                                    </v-flex>
                                    <v-flex xs4>
                                      <v-card
                                        color="info"
                                        class="full-width mr-2 py-4 px-1 text-xs-center"
                                        dark
                                      >
                                        <v-layout row wrap>
                                          <v-flex xs12 sm5 justify-center>
                                            <img
                                              src="@/assets/percent.svg"
                                              alt="percent"
                                              width="60"
                                              height="60"
                                            >
                                          </v-flex>
                                          <v-flex>
                                            <div class="pl-2">
                                              <h2 v-text="percent_done" class="py-2 text-sm-left"></h2>
                                              <h5 class="font-weight-regular">Percentage(%)</h5>
                                            </div>
                                          </v-flex>
                                        </v-layout>
                                      </v-card>
                                    </v-flex>
                                  </v-layout>

                                  <v-flex my-5 pa-3>
                                    <v-layout row wrap>
                                      <v-flex xs12 sm6 justify-center>
                                        <v-progress-circular
                                          :rotate="-90"
                                          :size="300"
                                          :width="45"
                                          :value="percent_done"
                                          color="success"
                                        >{{ percent_done }}%</v-progress-circular>
                                      </v-flex>
                                      <v-flex xs12 sm6>
                                        <v-layout column justify-center>
                                          <div>
                                            <div class="box success mr-2"></div>
                                            <h3 class="d-inline font-weight-regular">
                                              Percent Completed
                                              (<span v-text="percent_done"></span>%)
                                            </h3>
                                          </div>
                                          <div>
                                            <div class="box grey mr-2"></div>
                                            <h3
                                              class="d-inline font-weight-regular"
                                            >Total Percentage</h3>
                                          </div>
                                        </v-layout>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                          </v-tabs>
                        </div>
                      </v-layout>
                    </v-flex>
                  </div>

                  <div v-else>
                    <v-flex my-5>
                      <v-layout column>
                        <v-layout row wrap>
                          <div>
                            <h3 class="font-weight-regular">MERCHANTS</h3>
                          </div>
                          <v-spacer></v-spacer>
                          <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Search"
                            single-line
                            hide-details
                          ></v-text-field>
                        </v-layout>

                        <v-data-table
                          class="full-width"
                          :headers="headers"
                          :items="merchants"
                          :pagination.sync="pagination"
                          :total-items="count"
                          :loading="loading"
                          item-key="id"
                        >
                          <template slot="items" slot-scope="props">
                            <tr class="pointer" @click="toroute(props.item)">
                              <td>
                                <h3 class="font-weight-regular" v-text="props.item.merchant_name"></h3>
                                <h4 class="font-weight-regular" v-text="props.item.address"></h4>
                              </td>
                              <td class="text-xs-center" v-text="states[props.item.state]"></td>
                            </tr>
                          </template>
                          <v-alert
                            slot="no-results"
                            :value="true"
                            color="error"
                            icon="warning"
                          >Your search for "{{ search }}" route marshal has no results.</v-alert>
                        </v-data-table>
                      </v-layout>
                    </v-flex>
                  </div>
                </v-layout>
              </v-flex>
            </v-card-text>
            <v-snackbar
              v-model="snackbar.show"
              bottom
              right
              :color="snackbar.color"
              :timeout="snackbar.timeout"
            >
              {{ snackbar.text }}
              <v-flex justify-end>
                <v-btn
                  flat
                  v-if="snackbar.url"
                  :to="snackbar.url"
                  @click="snackbar.show = false"
                >Go to</v-btn>
                <v-btn flat @click="snackbar.show = false">Close</v-btn>
              </v-flex>
            </v-snackbar>
          </v-card>
        </template>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import downloadexcel from "vue-json-excel"
import AdminLayout from "../../layouts/admin"
import utils from "@/common/utils"
import { mapState, mapGetters } from "vuex"
import { FETCH_MERCHANT_LOCATIONS } from "@/store/actions/merchant"
import { DOWNLOAD_MARSHAL_REPORT } from "@/store/actions/ptspAdmin"
import { api, errorFn } from "@/common/apiService"
import { debounce } from "lodash"

export default {
  name: "AdminMarshal",
  components: {
    downloadexcel
  },
  data() {
    return {
      page_title: "Route Marshals",
      active: true,
      snackbar: {
        show: false,
        timeout: 7000,
        text: "",
        color: "",
        url: ""
      },
      loading: true,
      downloading: false,
      pagination: {
        sortBy: "emergency_visit",
        descending: true,
        rowsPerPage: 25
      },
      expand: false,
      view_report: false,
      start_date: new Date().toISOString().substr(0, 10),
      start_modal: false,
      end_date: new Date().toISOString().substr(0, 10),
      end_modal: false,
      tab_title: ["Weekly", "Monthly"],
      download_anal: false,
      getDate: new Date(),
      show_stats: true,
      search: "",
      reportSearch: "",
      json_fields: {
        Marshal: "marshal",
        Terminal: "terminal_uuid",
        "Merchant ID": "merchant_uuid",
        "Terminal Serial": "terminal_serial",
        "Terminal Type": "terminal_type",
        "Terminal App": "terminal_app",
        Bank: "bank",
        Merchant: "merchant_name",
        "Merchant address": "merchant_address",
        "Merchant Area": "merchant_area",
        Submitted: {
          field: "created",
          callback: value => {
            const d = new Date(value)
            return `${d.toDateString()} - ${d.toLocaleString("en-US", {
              hour: "numeric",
              minute: "numeric",
              hour12: true
            })}`
          }
        },
        comment: {
          field: "comment",
          callback: value => {
            return this.comments[value]
          }
        },
        remark: "remark",
        further_remark: "further_remark",
        tx_ref: "tx_ref",
        tx_amount: "tx_amount",
        "Emergency Visit": "emergency_visit",
        "Data Providers": {
          field: "data_providers",
          callback: value => {
            return this.dataProviders[value]
          }
        },
        "Further Action": "further_action",
        Item: {
          field: "item_name",
          callback: value => {
            return this.itemTypes[value]
          }
        },
        "Item Quantity": "item_quantity"
        // 'location': 'location'
      },
      headers: [
        {
          text: "Merchant",
          align: "left",
          value: "name"
        },
        { text: "State", value: "state" }
      ],
      reportsHeaders: [
        {text: "TID", align: "left", value: "terminal_uuid"},
        {text: "Name", value: "merchant_name"},
        {text: "Address", value: "merchant_address"},
        {text: "Date", value: "created"},
      ],
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      
    }
  },
  computed: {
    ...mapState({
      merchants: state => state.merchant.merchantLocations,
      count: state => state.merchant.merchantLocationsCount,
      reports: state => state.admin.rmReports
    }),
    percent_done() {
      return ((this.marshal.done / this.marshal.expected) * 100).toFixed(2)
    },
    marshal() {
      return this.$store.getters.getMarshalById(this.$route.params.id)
    },
    states() {
      return utils.choiceToDict(utils.STATE_CHOICES)
    },
    comments() {
      return utils.choiceToDict(utils.COMMENT_CHOICES)
    },
    dataProviders() {
      return utils.choiceToDict(utils.DATA_PROVIDERS)
    },
    itemTypes() {
      return utils.choiceToDict(utils.ITEM_CHOICES)
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi()
      }
    },
    search: function(newQuery, oldQuery) {
      this.loading = true
      this.debouncedSearchApi()
    }
  },
  methods: {
    convertUTCTime(utcTime) {
      if (utcTime) return utils.convertUTCTime(utcTime)
    },
    toroute(route) {
      this.$router.push(
        `/admin/merchants/${route.merchant}/locations/${route.id}`
      )
    },
    searchApi() {
      this.$store
        .dispatch(FETCH_MERCHANT_LOCATIONS, {
          marshal: this.$route.params.id,
          search: this.search,
          page: 1,
          page_size: this.pagination.rowsPerPage
        })
        .then(() => {
          this.loading = false
        })
    },
    getDataFromApi() {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      // Fetch data with page
      this.$store
        .dispatch(FETCH_MERCHANT_LOCATIONS, {
          marshal: this.$route.params.id,
          page: page,
          page_size: rowsPerPage,
          search: this.search
        })
        .then(() => {
          this.loading = false
        })
    },
    convertUTCTime(utcTime) {
      if (utcTime) return utils.convertUTCTime(utcTime)
    },
    async downloadReports() {
      // report_type = "working" filters for succeessful tx only
      this.downloading = true
      let query = {
        rm_id: this.$route.params.id,
        date_from: new Date(this.start_date).toISOString(),
        date_to: new Date(this.end_date).toISOString(),
        report_type: null
      }
      let url = "/rm-reports/"
      const resp = await api.get(url, { params: { ...query } })
      if (resp.data.length) {
        utils.showSnackbar({
          message:this.marshal.first_name,
          url:"",
          color:"primary darken-1",
        })
      }
      else {
        utils.showSnackbar({
          message:"No report submitted in date interval",
          url:"",
          color:"primary darken-1",
        })
      }
      this.download_anal = false
      this.downloading = false
      return resp.data
    }
  },
  created() {
    this.$emit("update:layout", AdminLayout)
    this.debouncedSearchApi = debounce(this.searchApi, 1000)
  },
  mounted() {
    // fetch rm's merchant locations
    const m = new Date()
    const n = new Date()
    m.setDate(1)
    m.setMonth(1)
    m.setHours(1)
    // n.setDate(m.getMonth() + 1)
    this.$store.dispatch(FETCH_MERCHANT_LOCATIONS, {
      marshal: this.$route.params.id,
      page: 1, 
      page_size: 25
    })
    this.$store.dispatch(DOWNLOAD_MARSHAL_REPORT, {
      rm_id: this.$route.params.id,
      date_from: m.toISOString(),
      date_to: n.toISOString(),
      report_type: null,
    })
  }
}
</script>

<style scoped>
.full-width {
  width: 100%
}
.box {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}
</style>

